module.exports = __webpack_public_path__ + "static/img/pic_PPT_vip@2x.7f762aa9.png";